import React from 'react';

const AiStarsGradientIcon = ({ size = 16, ...props }: { size?: number } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#ai-stars-gradient-clip)">
        <path
          d="M11.2823 8.75795C11.2833 8.8986 11.2428 9.0361 11.1664 9.15133C11.09 9.26656 10.9815 9.3538 10.856 9.40092L9.37975 9.96776C8.68298 10.2353 8.14025 10.7974 7.89726 11.5031L7.34442 13.1087C7.29828 13.24 7.2152 13.3532 7.10634 13.4331C6.99748 13.5131 6.86807 13.5559 6.73547 13.5559C6.60287 13.5559 6.47346 13.5131 6.3646 13.4331C6.25574 13.3532 6.17266 13.24 6.12652 13.1087L5.57363 11.5019C5.33045 10.7951 4.78669 10.2324 4.08869 9.96518L2.61492 9.40092C2.49061 9.3522 2.3834 9.26448 2.30769 9.14954C2.23199 9.0346 2.19141 8.89795 2.19141 8.75795C2.19141 8.61794 2.23199 8.48129 2.30769 8.36635C2.3834 8.25141 2.49061 8.16369 2.61492 8.11497L4.09188 7.5484C4.78967 7.28072 5.33304 6.71771 5.57578 6.01086L6.12652 4.40715C6.17266 4.2759 6.25574 4.1627 6.3646 4.08276C6.47346 4.00282 6.60287 3.95997 6.73547 3.95997C6.86807 3.95997 6.99748 4.00282 7.10634 4.08276C7.2152 4.1627 7.29828 4.2759 7.34442 4.40715L7.89731 6.01402C8.14049 6.72076 8.68425 7.28347 9.38225 7.55071L10.856 8.11497C10.9815 8.16209 11.09 8.24933 11.1664 8.36456C11.2428 8.47979 11.2833 8.61729 11.2823 8.75795Z"
          style={{ fill: 'url(#ai-stars-gradient-0)' }}
        />
        <path
          d="M13.8075 4.2125C13.8079 4.26432 13.7922 4.31498 13.7625 4.35743C13.7328 4.39988 13.6906 4.43202 13.6418 4.44938L12.8617 4.73314C12.7213 4.78421 12.6107 4.89483 12.5597 5.03525L12.2762 5.81542C12.2582 5.86378 12.2259 5.90548 12.1836 5.93494C12.1412 5.96439 12.0909 5.98017 12.0393 5.98017C11.9878 5.98017 11.9374 5.96439 11.8951 5.93494C11.8528 5.90548 11.8205 5.86378 11.8025 5.81542L11.5189 5.03449C11.4678 4.89387 11.357 4.78313 11.2164 4.73212L10.4369 4.44938C10.3886 4.43143 10.3469 4.39912 10.3174 4.35677C10.288 4.31442 10.2722 4.26408 10.2722 4.2125C10.2722 4.16092 10.288 4.11057 10.3174 4.06823C10.3469 4.02588 10.3886 3.99356 10.4369 3.97561L11.2175 3.69191C11.3582 3.64081 11.4689 3.53 11.5199 3.38935L11.8025 2.60957C11.8205 2.56122 11.8528 2.51951 11.8951 2.49006C11.9374 2.46061 11.9878 2.44482 12.0393 2.44482C12.0909 2.44482 12.1412 2.46061 12.1836 2.49006C12.2259 2.51951 12.2582 2.56122 12.2762 2.60957L12.5598 3.39051C12.6109 3.53113 12.7216 3.64187 12.8623 3.69288L13.6418 3.97561C13.6906 3.99297 13.7328 4.02511 13.7625 4.06757C13.7922 4.11002 13.8079 4.16068 13.8075 4.2125Z"
          style={{ fill: 'url(#ai-stars-gradient-1)' }}
        />
      </g>
      <defs>
        <linearGradient
          id="ai-stars-gradient-0"
          x1="7.99948"
          y1="2.44482"
          x2="7.99948"
          y2="13.5559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB93FF" />
          <stop offset="1" stopColor="#72CCDF" />
        </linearGradient>
        <linearGradient
          id="ai-stars-gradient-1"
          x1="7.99948"
          y1="2.44482"
          x2="7.99948"
          y2="13.5559"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CB93FF" />
          <stop offset="1" stopColor="#72CCDF" />
        </linearGradient>
        <clipPath id="ai-stars-gradient-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AiStarsGradientIcon;
